module.exports = __webpack_public_path__ + "img/djyq_lct@2x.de7e0d23.png";